import React, { useState, useEffect } from 'react'
import { Box, Textfield, SwxTheme } from 'swx-atomic-component-lib'
import _ from 'lodash'
import {
  textFieldStyle,
  iconRowStyle,
  formRowStyle,
  iconStyle
} from './style'

import UserIcon from 'calcite-ui-icons-react/UserIcon'
import i18n from '../../../i18n'

function UsernameFormComponent (props) {
  const [fnameError, setFnameError] = useState(false) // eslint-disable-line
  const [lnameError, setLnameError] = useState(false) // eslint-disable-line
  const [fnameErrorMsg, setFnameErrorMsg] = useState('') // eslint-disable-line
  const [lnameErrorMsg, setLnameErrorMsg] = useState('') // eslint-disable-line

  const fnameDebounced = _.debounce(onFnameChange, 275)
  const lnameDebounced = _.debounce(onLnameChange, 275)

  const { fnameValue, lnameValue, fnameChange, lnameChange, readOnly } = props

  // This is for reset
  // useEffect(() => {
  //   if (fnameValue === '' && fnameError) {
  //     setFnameError(false)
  //   }

  //   if (lnameValue === '' && lnameError) {
  //     setFnameError(false)
  //   }
  // }, [fnameValue, lnameValue, setFnameError, setLnameError])

  useEffect(() => {
    if (fnameError) {
      if (fnameValue.length > 50) {
        setFnameErrorMsg(i18n.signUpPage.error.userNameMax)
      } else if (fnameValue.length === 0) {
        setFnameErrorMsg(i18n.signUpPage.error.firstNameRequired)
      } else {
        setFnameErrorMsg(i18n.signUpPage.error.firstNameInvalidChar)
      }
    } else {
      setFnameErrorMsg('')
    }

    if (lnameError) {
      if (lnameValue.length > 50) {
        setLnameErrorMsg(i18n.signUpPage.error.userNameMax)
      } else if (lnameValue.length === 0) {
        setLnameErrorMsg(i18n.signUpPage.error.lastNameRequired)
      } else {
        setLnameErrorMsg(i18n.signUpPage.error.lastNameInvalidChar)
      }
    } else {
      setLnameErrorMsg('')
    }
  }, [fnameValue, lnameValue, fnameError, lnameError])

  function validateName (value) {
    // eslint-disable-next-line prefer-regex-literals
    return value.length > 50 || new RegExp('[=\\+\\-\\@]').test(value)
  }

  function onFnameChange (oriValue, elem) {
    const value = oriValue.trim()
    const isError = validateName(value)
    setFnameError(isError || value === '')
    fnameChange(value, isError || value === '')
  }

  function onLnameChange (oriValue, elem) {
    const value = oriValue.trim()
    const isError = validateName(value)
    setLnameError(isError || value === '')
    lnameChange(value, isError || value === '')
  }

  return (
    <Box customStyle={formRowStyle}>
      <Box customStyle={iconRowStyle} className='mobile-hide'>
        <UserIcon size={16} color={SwxTheme.palette.primary} style={iconStyle} />
      </Box>
      <Box customStyle={commonTextFieldOuterWrapperStyle} ml={3} className='mobile-stacked col-s-6'>
        <Box customStyle={nameTextFieldWrapperStyle} className='col-s-6 mobile-input-margin'>
          <Textfield
            type='text'
            placeholder={i18n.signUpPage.placeholder.firstName}
            customStyle={textFieldStyle}
            round
            value={fnameValue}
            onChange={fnameDebounced}
            error={fnameErrorMsg !== ''}
            message={fnameErrorMsg}
            color='primary'
            tabIndex='1'
            readOnly={readOnly}
          />
        </Box>
        <Box customStyle={nameTextFieldWrapperStyle} className='col-s-6 mobile-zero-margin'>
          <Textfield
            type='text'
            placeholder={i18n.signUpPage.placeholder.lastName}
            customStyle={textFieldStyle}
            round
            value={lnameValue}
            onChange={lnameDebounced}
            error={lnameErrorMsg !== ''}
            message={lnameErrorMsg}
            color='primary'
            tabIndex='2'
            readOnly={readOnly}
          />
        </Box>
      </Box>
    </Box>
  )
}

const commonTextFieldOuterWrapperStyle = `
  width: 100%;
  display: flex;
  flex: 1 1 auto;
`
const nameTextFieldWrapperStyle = `
  width: 50%;
  &:last-child {
    margin-left: 24px;
  }
`

export default UsernameFormComponent
